import type { Asset } from '@/api/common-types'
import { AssetImage } from '@/components/base/asset-image'
import { Photo } from '@/icons/photo'
import { clx } from '@/utils/clx'

type ThumbnailProps = {
	// Prefer the asset relation (correctly-sized derivative + blurhash placeholder); `src` is the
	// legacy fallback for products that only have `Product.imageUrl`.
	asset?: Asset | null
	src?: string | null
	alt?: string
	size?: 'small' | 'base'
}

const ThumbnailContent = ({ asset, src, alt }: Pick<ThumbnailProps, 'asset' | 'src' | 'alt'>) => {
	if (asset) {
		return (
			<AssetImage
				asset={asset}
				alt={alt}
				preferredVariant='THUMBNAIL'
				className='h-full w-full bg-transparent'
				imgClassName='object-contain object-center'
			/>
		)
	}
	if (src) {
		return <img src={src} alt={alt} className='h-full w-full object-contain object-center' />
	}
	return <Photo className='text-ui-fg-subtle' />
}

export const Thumbnail = ({ asset, src, alt, size = 'base' }: ThumbnailProps) => {
	return (
		<div
			className={clx(
				'flex items-center justify-center overflow-hidden rounded border border-ui-border-base bg-ui-bg-component',
				{
					'h-8 w-8': size === 'base',
					'h-5 w-5': size === 'small'
				}
			)}
		>
			<ThumbnailContent asset={asset} src={src} alt={alt} />
		</div>
	)
}
